import { TransitionProps } from '@material-ui/core/transitions';
import React from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import Dialog from '@material-ui/core/Dialog';
import IconButton from '@material-ui/core/IconButton';
import Icon from '@material-ui/core/Icon';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import DialogContent from '@material-ui/core/DialogContent';
import AppFunctionsService from '../../../services/appFunctionServices';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import TabPanel from '../../customComponents/tab/TabPanel';
import { RouteComponentProps, withRouter } from 'react-router';
import { IAvoBugAssignment } from '../../../types/model/avoBug/avoBugAssignment';
import AvoBugAssignmentInfoView from '../view/AssignmentInfoView';
import AvoBugAssignmentInfoResultView from '../view/AssignmentInfoResultView';

interface IAvoBugAssignmentInfoDialogProps extends RouteComponentProps {
    value : IAvoBugAssignment;

    fullWidth ?: boolean;
    maxWidth ?: 'xs' | 'sm' | 'md' | 'lg' | false;
    fullScreen ?: boolean;
    transition ?: React.ForwardRefExoticComponent<TransitionProps & React.RefAttributes<unknown>>;

    onClosed ?: () => void;
    defaultOpen ?: boolean;
}

interface IAvoBugAssignmentInfoDialogState {
    open : boolean;

    tabIndex : number;
}

class AvoBugAssignmentInfoDialogComponent extends React.PureComponent<IAvoBugAssignmentInfoDialogProps, IAvoBugAssignmentInfoDialogState> {
    private listener ?: () => void;
    
    constructor(props : IAvoBugAssignmentInfoDialogProps) {
        super(props);
        this.state = {
            open: false,
            tabIndex: 0,
        };
    }

    public readonly componentDidMount = () => {
        const open = !!this.props.defaultOpen || this.inPath();
        this.setState({
            open,
        });
    };

    private readonly inPath = () : boolean => {
        const urlParams = new URLSearchParams(this.props.location.search);

        const assignmentId = urlParams.get('assignmentId');

        return this.props.value.id === assignmentId;
    };

    private readonly onIconButtonClick = () => {
        this.setState({
            open: true,
        });
    };

    private readonly onClose = () => {
        const urlParams = new URLSearchParams(this.props.location.search);
        urlParams.delete('assignmentId');

        this.props.history.replace({
            pathname: this.props.location.pathname,
            search: urlParams.toString(),
        },);
        
        if (this.listener) {
            this.listener();
        }

        this.setState({
            open: false,
        });

        if (this.props.onClosed) this.props.onClosed();
    };

    private readonly onTabChange = (event : React.ChangeEvent<unknown>, value : number) => {
        this.setState({
            tabIndex: value,
        });
    };

    public readonly render = () => {
        const { transition, maxWidth, fullWidth, fullScreen, value, defaultOpen } = this.props;
        const { open, tabIndex } = this.state;

        return (
            <React.Fragment>
                {
                    !defaultOpen &&
                    <Tooltip title='Info'>
                        <div>
                            <IconButton color='primary' onClick={this.onIconButtonClick} aria-label='info'>
                                <Icon>info</Icon>
                            </IconButton>
                        </div>
                    </Tooltip>
                }
                <Dialog
                    open={open}
                    TransitionComponent={transition}
                    transitionDuration={500}
                    onClose={this.onClose}
                    maxWidth={maxWidth}
                    fullScreen={fullScreen}
                    fullWidth={fullWidth}
                    aria-labelledby='scouting-assignment-info-dialog-title'
                    aria-describedby='scouting-assignment-info-description'
                >
                    <AppBar elevation={0} className='fdc posr ais' position='static'>
                        <Toolbar variant='dense' className={'fdr'}>
                            <div className={'fdr flx1 aic'}>
                                <Typography variant='h5' color='inherit'>
                                    {
                                        `Assignment - ${AppFunctionsService.formatDateTimeToDateOnly(value.date)} -
                                        ${value.landName} -
                                        ${value.blockName}
                                        `
                                    }
                                </Typography>
                                <span className='flx1' />
                                <Tooltip title='Close'>
                                    <div>
                                        <IconButton color='inherit' onClick={this.onClose} aria-label='Close'>
                                            <Icon>close</Icon>
                                        </IconButton>
                                    </div>
                                </Tooltip>
                            </div>
                        </Toolbar>
                        <Tabs value={tabIndex} variant='fullWidth' onChange={this.onTabChange} aria-label='AssignmentTabs'>
                            <Tab value={0} label='INFO' />
                            <Tab value={1} label='RESULTS' />
                        </Tabs>
                    </AppBar>
                    <DialogContent className='fdc flx1 p0 bcg0'>
                        <TabPanel value={tabIndex} index={0}>
                            <AvoBugAssignmentInfoView value={value} />
                        </TabPanel>
                        <TabPanel value={tabIndex} index={1}>
                            <AvoBugAssignmentInfoResultView value={value} />
                        </TabPanel>
                    </DialogContent>
                </Dialog>
            </React.Fragment>
        );
    };
}

const AvoBugAssignmentInfoDialog = withRouter(AvoBugAssignmentInfoDialogComponent);

export default AvoBugAssignmentInfoDialog;